import * as H from 'history';
import { match } from 'react-router';
import {
  User,
  Users,
  Leads,
  Lead,
  LeadContacts,
  LeadPricing,
  LeadActivities,
  LeadGroup,
  LeadResources,
  BusinessPartner,
  Activities,
  ActivitiesCreateOrEdit,
  Question,
  Answer,
  Sidebar,
  Modal,
  State,
  OrderPad,
  OrderPadSales,
  PricingRequest,
  Utilities,
} from '.';

// Initialize all stores
const user = new User();
const modal = new Modal();
const users = new Users(user);
const leads = new Leads(user);
const lead = new Lead(leads, user);
const activities = new Activities(user, modal);
const leadContacts = new LeadContacts(lead);
const leadGroup = new LeadGroup(user, lead);
const pricingRequest = new PricingRequest(user);
const leadPricing = new LeadPricing(lead, pricingRequest, user);
const leadActivities = new LeadActivities(user, lead, activities);
const leadResources = new LeadResources(lead);
const businessPartner = new BusinessPartner(lead, leadContacts);
const activitiesCreateOrEdit = new ActivitiesCreateOrEdit(
  user,
  activities,
  leadActivities
);
const question = new Question(user);
const answer = new Answer(lead, question);
const sidebar = new Sidebar();
const orderPad = new OrderPad();
const orderPadSales = new OrderPadSales();
const state = new State(user);
const utilities = new Utilities(user);

// Store interface
export interface IAppStore {
  user: User;
  users: Users;
  leads: Leads;
  lead: Lead;
  leadContacts: LeadContacts;
  leadPricing: LeadPricing;
  leadActivities: LeadActivities;
  leadGroup: LeadGroup;
  leadResources: LeadResources;
  businessPartner: BusinessPartner;
  activities: Activities;
  modal: Modal;
  activitiesCreateOrEdit: ActivitiesCreateOrEdit;
  question: Question;
  answer: Answer;
  sidebar: Sidebar;
  orderPad: OrderPad;
  orderPadSales: OrderPadSales;
  state: State;
  pricingRequest: PricingRequest;
  utilities: Utilities;
}

// Initialize the store
const store: IAppStore = {
  user,
  users,
  leads,
  lead,
  leadContacts,
  leadPricing,
  leadActivities,
  leadGroup,
  leadResources,
  businessPartner,
  activities,
  activitiesCreateOrEdit,
  question,
  answer,
  sidebar,
  utilities,
  orderPad,
  orderPadSales,
  modal,
  pricingRequest,
  state,
};

// App interface
export interface IApp {
  store?: IAppStore;
  readonly history: H.History;
  readonly location: H.Location;
  readonly match: match<any>;
  readonly params: { [param: string]: string };
}

export interface IAppOnlyStore {
  store?: IAppStore;
}

export default store;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/AllStores.ts